export const US_POPULATION_21_PLUS_ID = 'sm_us_custom_age_21+';
